import { render, staticRenderFns } from "./PublicationsList.vue?vue&type=template&id=16a7ba28&scoped=true"
import script from "./PublicationsList.vue?vue&type=script&lang=js"
export * from "./PublicationsList.vue?vue&type=script&lang=js"
import style0 from "./PublicationsList.vue?vue&type=style&index=0&id=16a7ba28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7ba28",
  null
  
)

export default component.exports